import styled from '@emotion/styled';
import { Avatar, AvatarGroup, CardContent, Typography } from '@mui/material';
import React from 'react';

export const CustomCardContent = styled(CardContent)(({ theme }) => ({
  position: 'absolute',
  bottom: '0px',
  left: '0px',
  padding: '1.3rem',
  boxSizing: 'border-box',
  minHeight: '30%',
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  backgroundColor: 'transparent',
  borderRadius: '20px',
}));

export const TitleText = styled(Typography)(({ theme }) => ({
  color: '#ffffff',
  fontSize: '2rem',
  fontWeight: 'bold',
  width: '100%',
}));

export const ParaText = styled(Typography)(({ theme }) => ({
  color: '#ffffff',
  fontSize: '1.2rem',
  margin: '20px 0px',
}));

export const AvatarGroupText = styled(ParaText)(({ theme }) => ({
  width: 'max-content !important',
  height: 'auto !important',
  margin: 'auto !important',
  transition: 'all .2s linear',
}));

export const CustomAvatarGroup = styled(AvatarGroup)(({ theme }) => ({
  position: 'absolute',
  top: '10%',
  right: '6%',
  transform: 'translate(0%, -50%)',
  background: 'transparent',
  backdropFilter: 'blur(5px)',
  color: '#fff',
  padding: '8px',
  borderRadius: '20px',
  transition: 'width 1s linear',
  '& .MuiAvatarGroup-avatar': {
    width: '24px',
    height: '24px',
  },
  '& .avatar-group-text': {
    display: 'none',
    // transform: "scaleX(0)",
  },
  '& .hover-show': {
    display: 'none',
    // transform: "scaleX(0)",
  },
  '&:hover .avatar-group-text': {
    display: 'block',
    // transform: "scaleX(1)",
  },
  '&:hover .hover-show': {
    display: 'block',
    // transform: "scaleX(1)",
  },
}));

export const StackedAvatar = styled(Avatar)(({ theme }) => ({
  // width: "24px",
  // height: "24px",
}));

export const previewVideoStyles = {
  position: 'absolute',
  right: '50%',
  transform: 'translate(50%,-50%)',
  top: '50%',
  width: '100%',
  height: '100%',
  zIndex: '2',
  objectFit: 'cover',
  borderRadius: '25px',
  cursor: 'pointer',
} as React.CSSProperties;
